/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-02-06 11:05:00
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-02-06 11:57:23
 * @FilePath: \crm-product\src\views\dms\views\terminal\filiale_scan_in\form\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {};
  },
  methods: {
    beforeGetList() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const currentDate = `${year}-${month}-${day}`;
      if (
        !this.searchFormData.createTimeStart
        && !this.searchFormData.createTimeEnd
      ) {
        this.searchFormData = {
          ...this.searchFormData,
          createTimeStart: `${currentDate} 00:00:00`,
          createTimeEnd: `${currentDate} 23:59:59`,
        };
        this.formData = {
          ...this.formData,
          createTimeStart: `${currentDate} 00:00:00`,
          createTimeEnd: `${currentDate} 23:59:59`,
        };
      }
      return true;
    },
    afterGetList() {
      this.exportParams = this.paramsProps;
      return true;
    },
  },
  created() {
    this.getConfigList('detail_list');
  },
};
